import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {routingComponenets} from '../../app-routing.module';
import {AddVariantComponent} from '../items/add-variant/add-variant.component';
import {PrintReportComponent} from '../print-report/print-report.component';
import {EditItemComponent} from '../items/edit-item/edit-item.component';
import {AppsComponent} from '../apps/apps.component';
import {AppsActivationComponent} from '../apps-activation/apps-activation.component';
import {DriversComponent} from '../drivers/drivers.component';
import {FodiEatInfoComponent} from '../items/fodi-eat-info/fodi-eat-info.component';
import {OrdersListComponent} from '../orders-list/orders-list.component';
import {EmailComponent} from '../email/email.component';
import {ReasonComponent} from '../reason/reason.component';
import {HomeComponent} from '../home/home.component';
import {EditEmailComponent} from '../edit-email/edit-email.component';
import {AddItemsComponent} from '../add-items/add-items.component';
import {EditItemsComponent} from '../edit-items/edit-items.component';
import {jqxGridComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import {jqxCalendarComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcalendar';
import {jqxDateTimeInputComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdatetimeinput';
import {jqxDropDownListComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import {jqxLoaderComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';
import {StimulsoftReportComponent} from '../stimulsoft-report/stimulsoft-report.component';
import {jqxComboBoxComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcombobox';
import {jqxListBoxComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxlistbox';
import {CheckBarcodeDirective} from '../../directives/check-barcode.directive';
import {ValidNumberDirective} from '../../directives/valid-number.directive';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {NgxBarcodeModule} from 'ngx-barcode';
import {NgxEchartsModule} from 'ngx-echarts';
import {AutoCompleteModule, DropdownModule, StepsModule} from 'primeng/primeng';
import {TagInputModule} from 'ngx-chips';
import {NgProgressModule} from '@ngx-progressbar/core';
import {NgProgressHttpClientModule} from '@ngx-progressbar/http-client';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CKEditorModule} from 'ng2-ckeditor';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  imports: [
    CommonModule ,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    NgbModule ,
    CKEditorModule,
    // PerfectScrollbarModule,
    NgxBarcodeModule,
    NgxEchartsModule,
    AutoCompleteModule,
    DropdownModule,
    TagInputModule,
    StepsModule,
    NgMultiSelectDropDownModule.forRoot(),
      NgxPaginationModule
  ],
  declarations: [
    jqxGridComponent,
    jqxCalendarComponent,
    jqxDateTimeInputComponent,
    jqxDropDownListComponent,
    jqxLoaderComponent ,
    jqxComboBoxComponent,
    jqxListBoxComponent,
    CheckBarcodeDirective,
    ValidNumberDirective,
  ] ,
  exports:[
    // declarations
    jqxGridComponent,
    jqxCalendarComponent,
    jqxDateTimeInputComponent,
    jqxDropDownListComponent,
    jqxLoaderComponent ,
    jqxComboBoxComponent,
    jqxListBoxComponent,
    CheckBarcodeDirective,
    ValidNumberDirective,
    // imports
    CommonModule ,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule ,

    NgbModule ,
    CKEditorModule,
    // PerfectScrollbarModule,
    NgxBarcodeModule,
    NgxEchartsModule,
    AutoCompleteModule,
    DropdownModule,
    TagInputModule,
    StepsModule,
    NgMultiSelectDropDownModule
  ] ,
  providers:[NgMultiSelectDropDownModule]
})
export class SharedModule { }
